import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './fahrzeugverwendungsbestimmung.list-view.html',
  styleUrls: ['./fahrzeugverwendungsbestimmung.list-view.scss'],
})
export class FahrzeugverwendungsbestimmungListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
